(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[939],{

/***/ 26447:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export style */
/* harmony import */ var _babel_runtime_helpers_esm_objectWithoutPropertiesLoose__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(63366);
/* harmony import */ var _babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(87462);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _mui_system__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(95408);
/* harmony import */ var _mui_system__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(98700);
/* harmony import */ var _mui_system__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(39707);
/* harmony import */ var _mui_utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(59766);
/* harmony import */ var _styles_styled__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(90948);
/* harmony import */ var _styles_useThemeProps__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(71657);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);


const _excluded = ["component", "direction", "spacing", "divider", "children"];







/**
 * Return an array with the separator React element interspersed between
 * each React node of the input children.
 *
 * > joinChildren([1,2,3], 0)
 * [1,0,2,0,3]
 */

function joinChildren(children, separator) {
  const childrenArray = react__WEBPACK_IMPORTED_MODULE_0__.Children.toArray(children).filter(Boolean);
  return childrenArray.reduce((output, child, index) => {
    output.push(child);
    if (index < childrenArray.length - 1) {
      output.push( /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.cloneElement(separator, {
        key: `separator-${index}`
      }));
    }
    return output;
  }, []);
}
const getSideFromDirection = direction => {
  return {
    row: 'Left',
    'row-reverse': 'Right',
    column: 'Top',
    'column-reverse': 'Bottom'
  }[direction];
};
const style = ({
  ownerState,
  theme
}) => {
  let styles = (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
    display: 'flex',
    flexDirection: 'column'
  }, (0,_mui_system__WEBPACK_IMPORTED_MODULE_3__/* .handleBreakpoints */ .k9)({
    theme
  }, (0,_mui_system__WEBPACK_IMPORTED_MODULE_3__/* .resolveBreakpointValues */ .P$)({
    values: ownerState.direction,
    breakpoints: theme.breakpoints.values
  }), propValue => ({
    flexDirection: propValue
  })));
  if (ownerState.spacing) {
    const transformer = (0,_mui_system__WEBPACK_IMPORTED_MODULE_4__/* .createUnarySpacing */ .hB)(theme);
    const base = Object.keys(theme.breakpoints.values).reduce((acc, breakpoint) => {
      if (typeof ownerState.spacing === 'object' && ownerState.spacing[breakpoint] != null || typeof ownerState.direction === 'object' && ownerState.direction[breakpoint] != null) {
        acc[breakpoint] = true;
      }
      return acc;
    }, {});
    const directionValues = (0,_mui_system__WEBPACK_IMPORTED_MODULE_3__/* .resolveBreakpointValues */ .P$)({
      values: ownerState.direction,
      base
    });
    const spacingValues = (0,_mui_system__WEBPACK_IMPORTED_MODULE_3__/* .resolveBreakpointValues */ .P$)({
      values: ownerState.spacing,
      base
    });
    if (typeof directionValues === 'object') {
      Object.keys(directionValues).forEach((breakpoint, index, breakpoints) => {
        const directionValue = directionValues[breakpoint];
        if (!directionValue) {
          const previousDirectionValue = index > 0 ? directionValues[breakpoints[index - 1]] : 'column';
          directionValues[breakpoint] = previousDirectionValue;
        }
      });
    }
    const styleFromPropValue = (propValue, breakpoint) => {
      return {
        '& > :not(style) + :not(style)': {
          margin: 0,
          [`margin${getSideFromDirection(breakpoint ? directionValues[breakpoint] : ownerState.direction)}`]: (0,_mui_system__WEBPACK_IMPORTED_MODULE_4__/* .getValue */ .NA)(transformer, propValue)
        }
      };
    };
    styles = (0,_mui_utils__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(styles, (0,_mui_system__WEBPACK_IMPORTED_MODULE_3__/* .handleBreakpoints */ .k9)({
      theme
    }, spacingValues, styleFromPropValue));
  }
  styles = (0,_mui_system__WEBPACK_IMPORTED_MODULE_3__/* .mergeBreakpointsInOrder */ .dt)(theme.breakpoints, styles);
  return styles;
};
const StackRoot = (0,_styles_styled__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)('div', {
  name: 'MuiStack',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    return [styles.root];
  }
})(style);
const Stack = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(function Stack(inProps, ref) {
  const themeProps = (0,_styles_useThemeProps__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
    props: inProps,
    name: 'MuiStack'
  });
  const props = (0,_mui_system__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(themeProps);
  const {
      component = 'div',
      direction = 'column',
      spacing = 0,
      divider,
      children
    } = props,
    other = (0,_babel_runtime_helpers_esm_objectWithoutPropertiesLoose__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(props, _excluded);
  const ownerState = {
    direction,
    spacing
  };
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StackRoot, (0,_babel_runtime_helpers_esm_extends__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
    as: component,
    ownerState: ownerState,
    ref: ref
  }, other, {
    children: divider ? joinChildren(children, divider) : children
  }));
});
 false ? 0 : void 0;
/* harmony default export */ __webpack_exports__["Z"] = (Stack);

/***/ }),

/***/ 74223:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/pricing",
      function () {
        return __webpack_require__(72232);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 72232:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ pricing; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./src/layouts/MainLayout/index.js + 15 modules
var MainLayout = __webpack_require__(34316);
// EXTERNAL MODULE: ./node_modules/@mui/material/Box/Box.js + 1 modules
var Box = __webpack_require__(87357);
// EXTERNAL MODULE: ./node_modules/@mui/material/Container/Container.js + 1 modules
var Container = __webpack_require__(65582);
// EXTERNAL MODULE: ./node_modules/@mui/material/Typography/Typography.js
var Typography = __webpack_require__(23972);
// EXTERNAL MODULE: ./node_modules/@mui/material/Grid/Grid.js + 1 modules
var Grid = __webpack_require__(48263);
// EXTERNAL MODULE: ./node_modules/@mui/material/Fade/Fade.js
var Fade = __webpack_require__(16628);
// EXTERNAL MODULE: ./src/components/ResponsiveButton/index.js + 1 modules
var ResponsiveButton = __webpack_require__(97037);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 43 modules
var esm = __webpack_require__(22283);
// EXTERNAL MODULE: ./node_modules/@mui/material/utils/createSvgIcon.js
var createSvgIcon = __webpack_require__(82066);
;// CONCATENATED MODULE: ./node_modules/@mui/icons-material/esm/DoneOutline.js


/* harmony default export */ var DoneOutline = ((0,createSvgIcon/* default */.Z)( /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
  d: "m19.77 5.03 1.4 1.4L8.43 19.17l-5.6-5.6 1.4-1.4 4.2 4.2L19.77 5.03m0-2.83L8.43 13.54l-4.2-4.2L0 13.57 8.43 22 24 6.43 19.77 2.2z"
}), 'DoneOutline'));
// EXTERNAL MODULE: ./node_modules/@mui/material/Paper/Paper.js
var Paper = __webpack_require__(21987);
;// CONCATENATED MODULE: ./src/sections/pricing/components/Custom.js





const customBranded = {
    price: "SR 24,000",
    features: [
        "Add the logo of your school on the splash Screen",
        "Add the slogan of your school",
        "Customize the welcome screen (the splash screes) as you want",
        "Change text fonts, colors, background color",
        "Control what to show and what to hide on the app"
    ]
};
function Custom() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Paper/* default */.Z, {
        sx: {
            p: 6
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                variant: "body2",
                fontWeight: 700,
                sx: {
                    pb: 2
                },
                children: "Have A Custom Branded App For:"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                container: true,
                spacing: 1,
                alignItems: "flex-end",
                sx: {
                    pb: 6
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                        item: true,
                        xs: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            variant: "h4",
                            fontWeight: 700,
                            color: "primary.main",
                            children: customBranded.price
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                        item: true,
                        sx: {
                            display: {
                                xs: "none",
                                md: "block"
                            }
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ResponsiveButton/* default */.Z, {
                            color: "secondary",
                            variant: "contained",
                            "aria-label": "get started free",
                            children: "Get Started"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                container: true,
                spacing: 3,
                children: customBranded.features.map((feature, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                        item: true,
                        xs: 12,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                            container: true,
                            spacing: 2,
                            alignItems: "center",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                    item: true,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DoneOutline, {
                                        color: "primary"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                    item: true,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                        variant: "h6",
                                        fontWeight: 500,
                                        display: "inline",
                                        children: feature
                                    })
                                })
                            ]
                        })
                    }, index))
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ResponsiveButton/* default */.Z, {
                color: "secondary",
                variant: "contained",
                "aria-label": "get started free",
                sx: {
                    mt: 5,
                    display: {
                        xs: "block",
                        md: "none"
                    },
                    marginLeft: "auto",
                    marginRight: "auto"
                },
                children: "Get Started"
            })
        ]
    });
}
/* harmony default export */ var components_Custom = (Custom);

// EXTERNAL MODULE: ./node_modules/@tanstack/react-query/build/lib/useQuery.mjs + 6 modules
var useQuery = __webpack_require__(67848);
// EXTERNAL MODULE: ./src/api/httpClient.js + 4 modules
var httpClient = __webpack_require__(16799);
;// CONCATENATED MODULE: ./src/api/pricing.js


const KEYS = {
    PRICING: "pricing"
};
const getPricing = async ()=>{
    const response = await httpClient/* httpClient.get */.M.get("/features");
    return response.data;
};
const usePricing = function() {
    let locale = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "en";
    return (0,useQuery/* useQuery */.a)([
        KEYS.PRICING,
        "locale=".concat(locale)
    ], async ()=>getPricing(), {
        keepPreviousData: true
    });
};
const prefetchPricing = function(queryClient) {
    let locale = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "en";
    return queryClient.prefetchQuery([
        KEYS.PRICING,
        "locale=".concat(locale)
    ], async ()=>getPricing());
};

// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__(96486);
// EXTERNAL MODULE: ./node_modules/@mui/material/styles/styled.js
var styled = __webpack_require__(90948);
// EXTERNAL MODULE: ./node_modules/@mui/material/Switch/Switch.js
var Switch = __webpack_require__(72852);
;// CONCATENATED MODULE: ./src/components/AntSwitch/AntSwitch.js


const sizes = {
    small: 1,
    medium: 1.5,
    large: 2
};
const AntSwitch = (0,styled/* default */.ZP)(Switch/* default */.Z)((param)=>{
    let { theme , size ="medium"  } = param;
    return {
        width: 28 * sizes[size],
        height: 16 * sizes[size],
        padding: 0,
        "&:active": {
            "& .MuiSwitch-thumb": {
                width: 15 * sizes[size]
            },
            "& .MuiSwitch-switchBase.Mui-checked": {
                transform: "translateX(".concat(12 * sizes[size], "px)")
            }
        },
        ".MuiSwitch-track": {
            opacity: 1,
            backgroundColor: theme.palette.mode === "dark" ? "rgba(255,255,255,.35)" : "rgba(0,0,0,.25)",
            // border: '2px solid',
            borderColor: theme.palette.primary.gray
        },
        "& .MuiSwitch-switchBase": {
            padding: 2,
            "&.Mui-checked": {
                transform: "translateX(".concat(12 * sizes[size], "px)"),
                color: "#fff",
                "& + .MuiSwitch-track": {
                    // borderColor: `${theme.palette.primary.dark} !important`,
                    backgroundColor: theme.palette.mode === "dark" ? "#177ddc" : theme.palette.primary.main,
                    opacity: 1
                },
                "& .MuiSwitch-thumb": {
                }
            }
        },
        "& .MuiSwitch-thumb": {
            backgroundColor: theme.palette.primary.gray,
            width: 10 * sizes[size],
            height: 10 * sizes[size],
            borderRadius: 6 * sizes[size],
            transform: "translateX(".concat(1.25 * sizes[size], "px) translateY(").concat(1.25 * sizes[size], "px)"),
            transition: theme.transitions.create([
                "width"
            ], {
                duration: 200
            })
        },
        "& .MuiSwitch-track": {
            borderRadius: 16 / 2 * sizes[size],
            opacity: 1,
            // backgroundColor: theme.palette.mode === 'dark' ? 'rgba(255,255,255,.35)' : 'rgba(0,0,0,.25)',
            boxSizing: "border-box"
        }
    };
});
/* harmony default export */ var AntSwitch_AntSwitch = (AntSwitch);

;// CONCATENATED MODULE: ./src/components/AntSwitch/index.js


/* harmony default export */ var components_AntSwitch = (AntSwitch_AntSwitch);

;// CONCATENATED MODULE: ./node_modules/@mui/icons-material/esm/ErrorOutline.js


/* harmony default export */ var ErrorOutline = ((0,createSvgIcon/* default */.Z)( /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
  d: "M11 15h2v2h-2zm0-8h2v6h-2zm.99-5C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
}), 'ErrorOutline'));
;// CONCATENATED MODULE: ./node_modules/@mui/icons-material/esm/CheckCircle.js


/* harmony default export */ var CheckCircle = ((0,createSvgIcon/* default */.Z)( /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"
}), 'CheckCircle'));
;// CONCATENATED MODULE: ./node_modules/@mui/icons-material/esm/Cancel.js


/* harmony default export */ var Cancel = ((0,createSvgIcon/* default */.Z)( /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
  d: "M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59z"
}), 'Cancel'));
;// CONCATENATED MODULE: ./node_modules/@mui/icons-material/esm/KeyboardArrowDown.js


/* harmony default export */ var KeyboardArrowDown = ((0,createSvgIcon/* default */.Z)( /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
  d: "M7.41 8.59 12 13.17l4.59-4.58L18 10l-6 6-6-6 1.41-1.41z"
}), 'KeyboardArrowDown'));
// EXTERNAL MODULE: ./node_modules/@mui/material/Stack/Stack.js
var Stack = __webpack_require__(26447);
// EXTERNAL MODULE: ./node_modules/@mui/material/Collapse/Collapse.js
var Collapse = __webpack_require__(12509);
;// CONCATENATED MODULE: ./src/sections/pricing/components/RegularNarrow.js






function FeatureIcon(param) {
    let { check  } = param;
    if (typeof check !== "boolean") return /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorOutline, {
        color: "primary"
    });
    return check ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckCircle, {
        sx: {
            color: "success.dark",
            transform: "scaleX(1)!important"
        }
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Cancel, {
        sx: {
            color: "error.dark"
        }
    });
}
function PlanCard(param) {
    let { plan , featurePlans , mainSection , checkedState  } = param;
    var _mainSection_features;
    const { t  } = (0,esm/* useTranslation */.$G)();
    const [checked, setChecked] = checkedState;
    const [opened, setOpened] = react.useState(false);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Paper/* default */.Z, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                sx: {
                    p: 4
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                        direction: "row",
                        justifyContent: "space-between",
                        alignItems: "center",
                        spacing: 1,
                        sx: {
                            pb: 4
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                variant: "body2",
                                fontWeight: 400,
                                textTransform: "uppercase",
                                children: plan.name_text
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                                direction: "row",
                                alignItems: "center",
                                spacing: 1,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_AntSwitch, {
                                        inputProps: {
                                            "aria-label": "Billing"
                                        },
                                        checked: checked,
                                        onChange: (e)=>setChecked(e.target.checked)
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                        variant: "caption",
                                        fontSize: 14,
                                        fontWeight: 400,
                                        sx: {
                                            pt: 0.25
                                        },
                                        textTransform: "capitalize",
                                        display: "block",
                                        children: t("common:yearly")
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                        variant: "h4",
                        fontWeight: 700,
                        gutterBottom: true,
                        display: "block",
                        children: [
                            plan.amount,
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                variant: "body2",
                                fontWeight: 500,
                                component: "span",
                                children: [
                                    plan.currency,
                                    "/",
                                    plan.periodicity_type
                                ]
                            })
                        ]
                    }),
                    mainSection === null || mainSection === void 0 ? void 0 : (_mainSection_features = mainSection.features) === null || _mainSection_features === void 0 ? void 0 : _mainSection_features.map((feature)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                            variant: "body2",
                            fontSize: 13,
                            fontWeight: 400,
                            color: "primary.main",
                            display: "block",
                            children: [
                                feature.name_text,
                                " ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                    variant: "body2",
                                    fontSize: 15,
                                    fontWeight: 700,
                                    component: "span",
                                    children: feature.plans[plan.name]
                                })
                            ]
                        }, feature.name))
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Collapse/* default */.Z, {
                in: opened,
                children: featurePlans.map((param, index)=>/*#__PURE__*/ {
                    let { title , features  } = param;
                    return (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                sx: {
                                    backgroundColor: "#F9F9F9",
                                    pl: 4,
                                    py: 2
                                },
                                children: title
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                py: 2,
                                pl: 4,
                                pr: 2,
                                children: features.map((feature, idx)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                                        direction: "row",
                                        alignItems: "flex-start",
                                        spacing: 1.25,
                                        sx: {
                                            py: 1
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(FeatureIcon, {
                                                check: feature.plans[plan.name]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                                sx: {
                                                    pt: 0.2
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                        variant: "caption",
                                                        display: "inline",
                                                        children: feature.name_text
                                                    }),
                                                    " ",
                                                    typeof feature.plans[plan.name] !== "boolean" && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                        color: "primary.main",
                                                        variant: "caption",
                                                        display: "inline",
                                                        children: feature.plans[plan.name] >= 999999 ? t("pricing:Unlimited") : feature.plans[plan.name]
                                                    })
                                                ]
                                            })
                                        ]
                                    }, idx))
                            })
                        ]
                    }, index);
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                px: 4,
                py: 2,
                onClick: ()=>setOpened(!opened),
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                    direction: "row",
                    justifyContent: "space-between",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            variant: "caption",
                            fontWeight: 700,
                            textTransform: "capitalize",
                            children: t("pricing:show_features")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(KeyboardArrowDown, {
                            sx: {
                                transition: (theme)=>theme.transitions.create([
                                        "transform"
                                    ], {
                                        easing: theme.transitions.easing.sharp,
                                        duration: theme.transitions.duration.leavingScreen
                                    }),
                                transform: opened ? "rotate(180deg)" : "rotate(0deg)"
                            }
                        })
                    ]
                })
            })
        ]
    });
}
function RegularNarrow(param) {
    let { plans: allPlans , featurePlans: allFeaturePlans  } = param;
    var _sort, _ref, _allFeaturePlans_filter;
    const [checked, setChecked] = react.useState(true);
    const plans = (_sort = (_ref = [
        ...allPlans !== null && allPlans !== void 0 ? allPlans : []
    ]) === null || _ref === void 0 ? void 0 : _ref.sort((a, b)=>a.amount - b.amount)) === null || _sort === void 0 ? void 0 : _sort.filter((plan)=>(checked ? plan.periodicity_type === "Year" : plan.periodicity_type === "Month") || plan.name === "free");
    const featurePlans = allFeaturePlans === null || allFeaturePlans === void 0 ? void 0 : allFeaturePlans.filter((plan)=>plan.title !== "Main");
    const mainSection = (_allFeaturePlans_filter = allFeaturePlans === null || allFeaturePlans === void 0 ? void 0 : allFeaturePlans.filter((plan)=>plan.title === "Main")) === null || _allFeaturePlans_filter === void 0 ? void 0 : _allFeaturePlans_filter[0];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
        container: true,
        spacing: 4,
        children: plans.map((plan, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                item: true,
                xs: 12,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PlanCard, {
                    plan: plan,
                    featurePlans: featurePlans,
                    mainSection: mainSection,
                    checkedState: [
                        checked,
                        setChecked
                    ]
                })
            }, index))
    });
}
/* harmony default export */ var components_RegularNarrow = (RegularNarrow);

// EXTERNAL MODULE: ./node_modules/@mui/material/TableContainer/TableContainer.js
var TableContainer = __webpack_require__(4592);
// EXTERNAL MODULE: ./node_modules/@mui/material/Table/Table.js
var Table = __webpack_require__(13614);
// EXTERNAL MODULE: ./node_modules/@mui/material/TableBody/TableBody.js
var TableBody = __webpack_require__(58439);
// EXTERNAL MODULE: ./node_modules/@mui/material/TableRow/TableRow.js
var TableRow = __webpack_require__(75921);
// EXTERNAL MODULE: ./node_modules/@mui/material/TableCell/TableCell.js
var TableCell = __webpack_require__(98102);
// EXTERNAL MODULE: ./node_modules/@mui/material/TableFooter/TableFooter.js
var TableFooter = __webpack_require__(39549);
// EXTERNAL MODULE: ./src/imports/GetStartedButton/index.js + 1 modules
var GetStartedButton = __webpack_require__(41547);
;// CONCATENATED MODULE: ./src/sections/pricing/components/RegularWide.js







function RegularWide_FeatureIcon(param) {
    let { check  } = param;
    return check ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckCircle, {
        sx: {
            color: "success.dark",
            transform: "scaleX(1)!important"
        }
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Cancel, {
        sx: {
            color: "error.dark"
        }
    });
}
function RegularWide(param) {
    let { plans: allPlans , featurePlans: allFeaturePlans  } = param;
    var _sort, _ref, _allFeaturePlans_filter, _mainSection_features;
    const { t  } = (0,esm/* useTranslation */.$G)();
    const [checked, setChecked] = react.useState(true);
    const plans = (_sort = (_ref = [
        ...allPlans !== null && allPlans !== void 0 ? allPlans : []
    ]) === null || _ref === void 0 ? void 0 : _ref.sort((a, b)=>a.amount - b.amount)) === null || _sort === void 0 ? void 0 : _sort.filter((plan)=>checked ? plan.periodicity_type === "Year" : plan.periodicity_type === "Month");
    const featurePlans = allFeaturePlans === null || allFeaturePlans === void 0 ? void 0 : allFeaturePlans.filter((plan)=>plan.title !== "Main");
    const mainSection = (_allFeaturePlans_filter = allFeaturePlans === null || allFeaturePlans === void 0 ? void 0 : allFeaturePlans.filter((plan)=>plan.title === "Main")) === null || _allFeaturePlans_filter === void 0 ? void 0 : _allFeaturePlans_filter[0];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(TableContainer/* default */.Z, {
        component: Paper/* default */.Z,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Table/* default */.Z, {
            sx: {
                pt: 10,
                "& td:first-of-type": {
                    pl: 6
                },
                "& td:last-of-type": {
                    pr: 6
                }
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(TableBody/* default */.Z, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(TableRow/* default */.Z, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                                    sx: {
                                        border: 0
                                    }
                                }),
                                plans === null || plans === void 0 ? void 0 : plans.map((plan, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                                        align: "center",
                                        sx: {
                                            border: 0
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                            sx: {
                                                display: "flex",
                                                justifyContent: "center",
                                                mt: 2
                                            },
                                            children: [
                                                !!plan.special && /*#__PURE__*/ (0,jsx_runtime.jsx)(Paper/* default */.Z, {
                                                    sx: {
                                                        py: 1,
                                                        // px: 4,
                                                        backgroundColor: "secondary.main",
                                                        color: "secondary.contrastText",
                                                        position: "absolute",
                                                        top: -25,
                                                        zIndex: 2,
                                                        // left: 0,
                                                        // right: 0,
                                                        width: "125px",
                                                        margin: "auto"
                                                    },
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                        variant: "button",
                                                        fontWeight: 600,
                                                        fontSize: 18,
                                                        children: plan.special
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                    textTransform: "capitalize",
                                                    children: plan.name_text
                                                })
                                            ]
                                        })
                                    }, index))
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(TableRow/* default */.Z, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(TableCell/* default */.Z, {
                                    sx: {
                                        border: 0
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                            variant: "body2",
                                            color: "primary.main",
                                            fontWeight: 700,
                                            gutterBottom: true,
                                            display: "block",
                                            children: [
                                                "Billed ",
                                                checked ? "Annually" : "Monthly"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(components_AntSwitch, {
                                            inputProps: {
                                                "aria-label": "Billing"
                                            },
                                            checked: checked,
                                            onChange: (e)=>setChecked(e.target.checked)
                                        })
                                    ]
                                }),
                                plans.map((plan, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                                        align: "center",
                                        sx: {
                                            border: 0
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                            variant: "h5",
                                            fontWeight: 700,
                                            children: [
                                                plan.amount,
                                                " ",
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                                    variant: "caption",
                                                    fontWeight: 600,
                                                    component: "span",
                                                    children: [
                                                        plan.currency,
                                                        "/",
                                                        plan.periodicity_type
                                                    ]
                                                })
                                            ]
                                        })
                                    }, index))
                            ]
                        }),
                        mainSection === null || mainSection === void 0 ? void 0 : (_mainSection_features = mainSection.features) === null || _mainSection_features === void 0 ? void 0 : _mainSection_features.map((feature)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)(TableRow/* default */.Z, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                                        sx: {
                                            border: 0
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                            variant: "body2",
                                            fontWeight: 700,
                                            children: feature.name_text
                                        })
                                    }),
                                    plans.map((plan, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                                            align: "center",
                                            sx: {
                                                border: 0
                                            },
                                            children: typeof feature.plans[plan.name] !== "boolean" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                variant: "body2",
                                                fontWeight: 600,
                                                color: "primary.main",
                                                children: feature.plans[plan.name]
                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(RegularWide_FeatureIcon, {
                                                check: feature.plans[plan.name]
                                            })
                                        }, index))
                                ]
                            }, feature.name)),
                        featurePlans.map((param, index)=>/*#__PURE__*/ {
                            let { title , features  } = param;
                            return (0,jsx_runtime.jsxs)(react.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TableRow/* default */.Z, {
                                        sx: {
                                            backgroundColor: "#F9F9F9"
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                                            sx: {
                                                border: 0,
                                                py: 3
                                            },
                                            colSpan: plans.length + 1,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                variant: "h6",
                                                fontWeight: 700,
                                                children: title
                                            })
                                        })
                                    }),
                                    features.map((feature, idx)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)(TableRow/* default */.Z, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                                                    sx: {
                                                        borderWidth: features.length > idx + 1 ? 1 : 0,
                                                        borderRightWidth: 1,
                                                        borderRight: "1px solid rgba(224, 224, 224, 1)"
                                                    },
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                        variant: "body2",
                                                        fontWeight: 500,
                                                        children: feature.name_text
                                                    })
                                                }),
                                                plans.map((plan, i)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                                                        align: "center",
                                                        sx: {
                                                            borderWidth: features.length > idx + 1 ? 1 : 0,
                                                            borderRight: plans.length > i + 1 ? "1px solid rgba(224, 224, 224, 1)" : "unset"
                                                        },
                                                        children: typeof feature.plans[plan.name] !== "boolean" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                            variant: "body2",
                                                            fontWeight: 600,
                                                            color: "primary.main",
                                                            children: feature.plans[plan.name] >= 999999 ? t("pricing:Unlimited") : feature.plans[plan.name]
                                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(RegularWide_FeatureIcon, {
                                                            check: feature.plans[plan.name]
                                                        })
                                                    }, i))
                                            ]
                                        }, idx))
                                ]
                            }, index);
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(TableFooter/* default */.Z, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(TableRow/* default */.Z, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                                sx: {
                                    borderTop: "1px solid rgba(224, 224, 224, 1)"
                                }
                            }),
                            plans.map((_, i)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(TableCell/* default */.Z, {
                                    align: "center",
                                    sx: {
                                        borderTop: "1px solid rgba(224, 224, 224, 1)"
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(GetStartedButton/* default */.Z, {
                                        sx: {
                                            minWidth: 150,
                                            borderRadius: 10,
                                            fontSize: 16
                                        },
                                        color: "primary",
                                        label: t("common:get_started")
                                    })
                                }, i))
                        ]
                    })
                })
            ]
        })
    });
}
/* harmony default export */ var components_RegularWide = (RegularWide);

;// CONCATENATED MODULE: ./src/sections/pricing/components/Regular.js








function Regular() {
    var _pricingQuery_data, _pricingQuery_data1, _pricingQuery_data2;
    const { i18n  } = (0,esm/* useTranslation */.$G)();
    const pricingQuery = usePricing(i18n.language);
    var _pricingQuery_data_features;
    const features = (0,lodash.groupBy)((_pricingQuery_data_features = (_pricingQuery_data = pricingQuery.data) === null || _pricingQuery_data === void 0 ? void 0 : _pricingQuery_data.features) !== null && _pricingQuery_data_features !== void 0 ? _pricingQuery_data_features : [], "section");
    const featurePlans = Object.entries(features).map((param)=>{
        let [key, items] = param;
        return {
            title: key,
            features: items
        };
    });
    var _pricingQuery_data_plans, _pricingQuery_data_plans1;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                sx: {
                    display: {
                        xs: "none",
                        md: "block"
                    },
                    position: "relative"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_RegularWide, {
                    plans: (_pricingQuery_data_plans = pricingQuery === null || pricingQuery === void 0 ? void 0 : (_pricingQuery_data1 = pricingQuery.data) === null || _pricingQuery_data1 === void 0 ? void 0 : _pricingQuery_data1.plans) !== null && _pricingQuery_data_plans !== void 0 ? _pricingQuery_data_plans : [],
                    featurePlans: featurePlans
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                sx: {
                    display: {
                        xs: "block",
                        md: "none"
                    },
                    position: "relative"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_RegularNarrow, {
                    plans: (_pricingQuery_data_plans1 = pricingQuery === null || pricingQuery === void 0 ? void 0 : (_pricingQuery_data2 = pricingQuery.data) === null || _pricingQuery_data2 === void 0 ? void 0 : _pricingQuery_data2.plans) !== null && _pricingQuery_data_plans1 !== void 0 ? _pricingQuery_data_plans1 : [],
                    featurePlans: featurePlans
                })
            })
        ]
    });
}
/* harmony default export */ var components_Regular = (Regular);

;// CONCATENATED MODULE: ./src/sections/pricing/PricingSection.js







function PricingSection() {
    const { t  } = (0,esm/* useTranslation */.$G)();
    const [type, setType] = react.useState("regular");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                sx: {
                    backgroundColor: "primary.main",
                    color: "primary.contrastText"
                },
                pt: 15,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
                    maxWidth: "md",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                            variant: "h2",
                            textAlign: "center",
                            fontWeight: 300,
                            sx: {
                                pb: 6
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                    variant: "h2",
                                    textAlign: "center",
                                    component: "span",
                                    children: t("pricing:hero_pricing_ar")
                                }),
                                " ",
                                t("pricing:hero_simple"),
                                " ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                    variant: "h2",
                                    textAlign: "center",
                                    component: "span",
                                    children: t("pricing:hero_pricing")
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            variant: "subtitle1",
                            textAlign: "center",
                            fontWeight: 300,
                            sx: {
                                maxWidth: 591,
                                margin: "auto",
                                pb: 11
                            },
                            children: t("pricing:hero_title")
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                            container: true,
                            spacing: 2,
                            justifyContent: "center",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                    item: true,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ResponsiveButton/* default */.Z, {
                                        sx: {
                                            width: 280,
                                            borderRadius: 10
                                        },
                                        variant: type === "regular" ? "contained" : "outlined",
                                        onClick: ()=>setType("regular"),
                                        color: "paper",
                                        "aria-label": "regular plans",
                                        children: t("pricing:regular_plans")
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                    item: true,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ResponsiveButton/* default */.Z, {
                                        sx: {
                                            width: 280,
                                            borderRadius: 10
                                        },
                                        variant: type === "custom" ? "contained" : "outlined",
                                        onClick: ()=>setType("custom"),
                                        color: "paper",
                                        "aria-label": "custom branded app",
                                        children: t("pricing:custom_branded_app")
                                    })
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                sx: {
                    width: "125%",
                    left: "-12.5%",
                    height: "200px",
                    overflow: "hidden",
                    borderBottomLeftRadius: "50% 100%",
                    borderBottomRightRadius: "50% 100%",
                    backgroundColor: "primary.main",
                    position: "relative",
                    zIndex: -2
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
                maxWidth: "md",
                sx: {
                    mt: -10,
                    pb: 12
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Fade/* default */.Z, {
                        in: type === "regular",
                        sx: {
                            display: type === "regular" ? "block" : "none"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Regular, {})
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Fade/* default */.Z, {
                        in: type === "custom",
                        sx: {
                            display: type === "custom" ? "block" : "none"
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Custom, {})
                        })
                    })
                ]
            })
        ]
    });
}
/* harmony default export */ var pricing_PricingSection = ((/* unused pure expression or super */ null && (PricingSection)));

;// CONCATENATED MODULE: ./src/sections/pricing/index.js


// EXTERNAL MODULE: ./src/sections/home/index.js + 27 modules
var home = __webpack_require__(86874);
;// CONCATENATED MODULE: ./pages/pricing.js







function Pricing() {
    const { t  } = (0,esm/* useTranslation */.$G)([
        "meta"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((head_default()), {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                    children: "".concat(t("meta:pricing.title"), " - Blue Assembly")
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(MainLayout/* default */.C, {
                navbarProps: {
                    dark: true
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PricingSection, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(home/* PreFooterSection */.jq, {})
                ]
            })
        ]
    });
}
var __N_SSG = true;
/* harmony default export */ var pricing = ((0,esm/* withTranslation */.Zh)([
    "common"
])(Pricing));


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [6,809,718,558,367,172,80,316,874,774,888,179], function() { return __webpack_exec__(74223); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);